var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-crud-page',{attrs:{"master":"bunker_location","title":"Bunker Location","access":"master_bunker_location","pk":"mbloId","columns":_vm.columns,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }